import moment from 'moment';

import environment from '../../../environment';
import fetch from '../../fetch';

const sales = (() => {
    const get = {
        area (id, beginyear, endyear, models, brands) {
            let data = { id };
            data.anoMesInicio = beginyear || moment(environment.get('CONFIG.FILTERS.ENDYEAR')).subtract(1, 'year').startOf('year').format('YYYYMM');
            data.anoMesFim = endyear || moment(environment.get('CONFIG.FILTERS.ENDYEAR')).format('YYYYMM');
            if (models || brands) {
                data.idsCategorias = models || '';
                data.idsBandeiras = brands || '';
            }

            return fetch({
                type: 'GET',
                url: `${environment.get('API_HOST')}/agrupamento/ObterEmplacamentosAreaDemarcada/`,
                header: {
                    'X-UIKey': 'operational-area-dashboard-view'
                },
                data,
                success (res) {
                    data = {
                        beginDate: data.anoMesInicio,
                        endDate: data.anoMesFim,
                        values: res
                    };
                    return data;
                }
            });
        },

        location (id, beginyear, endyear, models, brands) {
            let data = { id };
            data.anoMesInicio = beginyear || moment(environment.get('CONFIG.FILTERS.ENDYEAR')).subtract(1, 'year').startOf('year').format('YYYYMM');
            data.anoMesFim = endyear || moment(environment.get('CONFIG.FILTERS.ENDYEAR')).format('YYYYMM');
            if (models || brands) {
                data.idsCategorias = models || '';
                data.idsBandeiras = brands || '';
            }

            return fetch({
                type: 'GET',
                url: `${environment.get('API_HOST')}/agrupamento/ObterEmplacamentosLocalidade/`,
                header: {
                    'X-UIKey': 'area-selection-dashboard-view'
                },
                data,
                success (res) {
                    data = {
                        beginDate: data.anoMesInicio,
                        endDate: data.anoMesFim,
                        values: res
                    };
                    return data;
                }
            });
        },

        origindestiny (id, beginyear, endyear, models, brands) {
            const data = { id };
            data.anoMesInicio = beginyear || moment(environment.get('CONFIG.FILTERS.ENDYEAR')).subtract(1, 'year').startOf('year').format('YYYYMM');
            data.anoMesFim = endyear || moment(environment.get('CONFIG.FILTERS.ENDYEAR')).format('YYYYMM');
            if (models || brands) {
                data.idsCategorias = models || '';
                data.idsBandeiras = brands || '';
            }

            return fetch({
                type: 'GET',
                url: `${environment.get('API_HOST')}/agrupamento/ObterEmplacamentosOrigemDestino`,
                header: {
                    'X-UIKey': 'Operational-area-origin-destination-view'
                },
                data
            });
        },
    };

    return {
        get
    };
})();

export default sales;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/sales/index.js